import { useState } from "react";
import { Trash2, X } from "lucide-react";
import { RECYCLE_ITEMS } from "@/data/misc";
import { useAchievements } from "@/os/state/achievements";
import { useToast } from "@/os/state/toast";
import { play } from "@/lib/sound";

export function RecycleBin() {
    const [openId, setOpenId] = useState<string | null>(null);
    const { trackEgg } = useAchievements();
    const { push } = useToast();
    const item = RECYCLE_ITEMS.find((r) => r.id === openId);

    return (
        <div className="relative" data-testid="recycle-bin">
            <p className="font-mono text-[11px] text-inkfaint">5 items. deletion here is mostly theatrical.</p>
            <div className="mt-3 space-y-1">
                {RECYCLE_ITEMS.map((r) => (
                    <button
                        key={r.id}
                        data-testid={`recycle-item-${r.id}`}
                        className="file-row"
                        onClick={() => {
                            play("click");
                            if (r.egg) trackEgg("egg_recycle_secret");
                            setOpenId(r.id);
                        }}
                    >
                        <Trash2 size={15} style={{ color: "#64748B", flex: "none" }} />
                        <span className="truncate">{r.name}</span>
                        <span className="file-meta">{r.meta}</span>
                    </button>
                ))}
            </div>
            <div className="mt-4 flex flex-wrap gap-2">
                <button
                    data-testid="recycle-restore"
                    className="btn btn-sm"
                    onClick={() => {
                        play("click");
                        push("system", "restore failed", "some deletions are permanent. on purpose.");
                    }}
                >
                    Restore all
                </button>
                <button
                    data-testid="recycle-empty"
                    className="btn btn-sm"
                    onClick={() => {
                        play("click");
                        push("system", "bin emptied", "it refills automatically. like tabs.");
                    }}
                >
                    Empty recycle bin
                </button>
            </div>

            {item && (
                <div className="absolute inset-0 z-30 grid place-items-center rounded-2xl bg-ink/30 p-3" data-testid="recycle-popup">
                    <div className="pop-in max-h-full w-full overflow-auto os-scroll rounded-2xl border-2 border-ink bg-paper p-4 shadow-[5px_5px_0_#1C1917]">
                        <div className="flex items-center gap-2">
                            <Trash2 size={15} className="flex-none text-inkfaint" />
                            <p className="flex-1 truncate font-mono text-[12px] font-bold">{item.name}</p>
                            <button data-testid="recycle-popup-close" aria-label="Close" className="text-inkfaint hover:text-ink" onClick={() => setOpenId(null)}>
                                <X size={15} />
                            </button>
                        </div>
                        {item.popup.map((l, i) => (
                            <p key={i} className="mt-2 text-[13px] leading-relaxed text-inksoft">
                                {l}
                            </p>
                        ))}
                        {item.egg && <span className="badge mt-3 border-lav text-lav">easter egg · {item.name}</span>}
                    </div>
                </div>
            )}
        </div>
    );
}
